module.exports = __webpack_public_path__ + "static/img/jianzhi3.88e5a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-parttime/jianzhi3.png
// module id = 06Kx
// module chunks = 1